module.exports = __webpack_public_path__ + "media/images/louise-yoga-1979d4d8.jpg";